module.exports = __webpack_public_path__ + "img/support2.8e3ea3bf.png";